module.exports = __webpack_public_path__ + "img/comments.976a8c66.svg";